import { Component } from '@angular/core';

interface InterestItem {
  title: string;
  description: string;
  route: string;
  iconClass?: string;
}


@Component({
  selector: 'app-dashboard-grid',
  templateUrl: './dashboard-grid.component.html',
  styleUrls: ['./dashboard-grid.component.scss']
})

export class DashboardGridComponent {
  // Let's say you have an array of "interests" that you want to render
  interests: InterestItem[] = [
    {
      title: 'Family',
      description: 'Projects for my wife Sabrina, and our three grandchildren, August, Liam and Liv.',
      iconClass: 'bi bi-house-door-fill', // Using a Bootstrap icon class, if you want
      route: 'family'
    },
    {
      title: 'All My Hugs',
      description: 'a family friendly Canadian company created to provide a way for loved ones to connect across distance, across time and across generations',
      iconClass: 'bi bi-box2-heart-fill', // Using a Bootstrap icon class, if you want
      route: 'allmyhugs'
    },
    {
      title: 'Norametrics',
      description: 'A free speech centric moderation company that cares about your businesses success and online reputation in an ever changing social climate.',
      iconClass: 'bi bi-clipboard2-data-fill',
      route: 'norametrics'
    },
    {   
      title: 'News Responders',
      description: 'Finally a site where the public can discuss news stories honestly and openly without the fear of being silenced or Ghost Banned.',
      iconClass: 'bi bi-newspaper',
      route: 'newsresponders'
    },
    {
      title: 'The Monastery of Real Things',
      description: 'A library of credentialed, authenticated and verified significant media events. An attempt to verify what is real in an AI world and to capture analogue data to preserve history accurately.',
      iconClass: 'bi bi-wrench-adjustable',
      route: 'monastery'
    },
    {
      title: 'Education for All',
      description: 'Courses I\'m creating in Music Theory and Programming for anyone who loves music or for some insane reason wants to build their own software.',
      iconClass: 'bi bi-feather',
      route: 'education'
    },
    {
      title: 'Travel',
      description: 'I prefer to be moving and I prefer to be walking when I am.',
      iconClass: 'bi bi-car-front-fill',
      route: 'travel'
    },
    {
      title: 'Community Development',
      description: 'Local courses offered in micro farming, tactile skills etc.',
      iconClass: 'bi bi-globe',
      route: 'community'
    },
    {
      title: 'Remote Career Board',
      description: 'Dont freelance for peanuts, work for points. Own the projects you develop. Find them here. ',
      iconClass: 'bi bi-person-workspace',
      route: 'remotecareerboard'
    },
    {
      title: 'Biz Base Begin',
      description: 'We are a business development company that helps you get started with a ready to go solution. Whether you are a single person starting a small business or midsized company we have what you need to hit the ground running',
      iconClass: 'bi bi-inboxes-fill',
      route: 'bizbasebegin'
    }
    ,
    {
      title: 'Life Base Begin',
      description: 'A tool for managing your life while learning all the things you need to know that they didnt teach you in school.',
      iconClass: 'bi bi-people-fill',
      route: 'lifebasebegin'
    }
    ,
    {
      title: 'Anti-Social Media',
      description: 'Social Media that is not social. A social conversation wall that you share with one person only. ',
      iconClass: 'bi bi-ban',
      route: 'antisocialmedia'

    }
    ,
    {
      title: 'HowdjyaDoit',
      description: 'A podcast where we interview successful people to find out how they did it. Whether it was buying a rental property or starting their business this is where you can learn how they started, and how they made it work. ',
      iconClass: 'bi bi-patch-question-fill',
      route: 'howdjyadoit'
    } 
    ,
    {
      title: 'My Lobby of Hobbies',
      description: 'When spare time happens: Recording Brand New Original 1970s Rock and Roll and building Miniature landscapes and structures. ',
      iconClass: 'bi bi-tools',
      route: 'mylobbyofhobbies'
    },
    {
      title: 'Hopes and Dreams',
      description: 'A perfect property to renovate in Spain, Croatia or maybe even Atlantic Canada with a small farm, outbuildings and a view of the ocean. ',
      iconClass: 'bi bi-cloud-sun-fill',
      route: 'hopesanddreams'
    }
  ];
}